export default __webpack_public_path__ + "static/media/colin_admiring_canopy.b989e771.jpg";